import {Component} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {RouterLink} from '@angular/router';
import {RouterContextDirective} from '@core/directives/router-context.directive';

@Component({
  selector: 'app-footer-our-stores',
  templateUrl: './footer-our-stores.component.html',
  styleUrl: './footer-our-stores.component.scss',
  imports: [
    NgOptimizedImage,
    RouterLink,
    RouterContextDirective
  ]
})
export class FooterOurStoresComponent {

}
